<template>
	<div class="w-full bg-primary-500 flex divide-x-[1px] divide-primary-300 [&>*]:px-6 [&>*]:py-4 [&>*]:w-full">
		<slot />
	</div>
</template>
